module.exports = __webpack_public_path__ + "img/camping-pods.2.6d20b50.jpg";